var map = {
	"./take/Index": [
		680,
		254
	],
	"./take/devices/mobile/Index": [
		681,
		0,
		255
	],
	"./takecourse/Index": [
		345,
		45
	],
	"./takecourse/devices/mobile/Index": [
		346,
		0,
		48
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 482;
module.exports = webpackAsyncContext;